/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { Link, useHistory, BrowserRouter } from "react-router-dom";
import React, { useState, useEffect, useContext, useRef } from "react";

// Materila ui
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import FilledInput from "@material-ui/core/FilledInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import Input from "@material-ui/core/Input";
import TextField from "@material-ui/core/TextField";
import LockIcon from "@material-ui/icons/Lock";
import EmailIcon from "@material-ui/icons/Email";
import Checkbox from "@material-ui/core/Checkbox";
import { useTheme } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import Page from "../Components/Page";
// import { useNavigate} from "react-router"
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Axios from "axios";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";
import clsx from "clsx";
import ChangePassword from "../Components/ChangePassword";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { withTranslation, useTranslation, Trans } from "react-i18next";

// component importing
import SignUpDialog from "./SignUpModal";
import LoginGoogle from "./LoginGoogle"
import FbLogin from "./FbLogin"
import AppleLogin from "./AppleLogin"

// cookies Funtions
import { setCookie } from "../Functions/cookieFunction";
import { handleError } from "../Functions/getAlert";

const styles = (theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  wrapper: {
    marginTop: "1.5rem",
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});
const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton   
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function LoginDialog({ handleClose, open,handleLoginOpen }) {
  const classes = useStyles();
  const [checked, setChecked] = React.useState(true);
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const [check_status, setCheck_status] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
  });
  const [loginValues, setLoginValues] = useState({ email: "", password: "" });
  const [success, setSuccess] = useState(false);
  const { t } = useTranslation();

  const [openSignUp, setOpenSignUp] = useState(false);
  const handleClickOpenSignUp = () => {
    setOpenSignUp(true);
  };
  const handleCloseSignUp = () => {
    setOpenSignUp(false);
  };

  const handleLogout = () => {
    appDispatch({ type: "logout" });
    setAlertMessage({ open: true, message: "Logout !", alertSuccess: true });
    setLoading(false);
  };
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });
  // if (appState.loggedIn) { history.push('/dashboard') }
  
  const handleLoginSubmit = async (e) => {
    setLoading(true);
    setSuccess(false);
    e.preventDefault();
    if (loginValues.email && loginValues.password !== "") {
      try {
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}customer/login`,
          { username: loginValues.email, password: loginValues.password }
        );
        if (response.data.success) {
          setSuccess(true);
          appDispatch({
            type: "login",
            login: response.data.data.id,
            token: response.data.data.token,
          });
          appDispatch({ type: "addProfileData", profile: response.data.data });
          localStorage.setItem("Profile", JSON.stringify(response.data.data));
          if (check_status) {
            setCookie("tokenAuth", response.data.data.token, 365);
          } else {
            setCookie("tokenAuth", response.data.data.token);
          }
          setCookie("Profile", JSON.stringify(response.data.data));
          localStorage.setItem("Profile", JSON.stringify(response.data.data));
          handleClose();
        setAlertMessage({
          open: true,
          message: response.data.message,
          alertSuccess: true,
        });
          setLoading(false);
        }
      } catch (e) {
        setLoading(false);
      }
    } else {
      setLoading(false);
      setAlertMessage({
        open: true,
        message: "Please fill these fields!",
        alertSuccess: false,
      });
    }
  };

  const updateField = (e) => {
    setLoginValues({
      ...loginValues,
      [e.target.name]: e.target.value,
      [e.target.password]: e.target.value,
    });
  };

  const [changeStatus, setChangeStatus] = useState(false);
  const handleForget = () => {
    setChangeStatus(true);
  };

  // FORGOT PASSWORD START 
  const [ForgotValues, setForgotValues] = useState({ email: "" });
  const updateFieldForgot = (e) => {
    setForgotValues({
      ...ForgotValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmitForgotPassword = async (e) => {
    setLoading(true);
    setSuccess(false);
    e.preventDefault();
    if (ForgotValues.email) {
      try {
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}forget/password`,
          { email: ForgotValues.email }
        )
          if(response.data.success == false)
          {
            setLoading(false);
            setAlertMessage({
              open: true,
              message: response.data.message,
              alertSuccess: false,
            });
          }else if(response.data.success == false)
          {
            setLoading(false);
            setAlertMessage({
              open: true,
              message: response.data.message,
              alertSuccess: true,
            });
          }
      
      } catch (e) {
        setLoading(false);
        handleError(e, appDispatch)
      }
    } else {
      setLoading(false);
      setAlertMessage({
        open: true,
        message: "Please fill these fields!",
        alertSuccess: false,
      });
    }
  };
  // FORGOT PASSWORD End Sikandar

  // update password start

  const [showUpdatePasswordModal, setShowUpdatePasswordModal] = useState(false);
  const [userIdForUpdatePassword, setuserIdForUpdatePassword] = useState("");
  const [toggleCurrentPassword, setToggleCurrentPassword] = useState(false);
  const togglePassTypeCurrent = () => {
    setToggleCurrentPassword(!toggleCurrentPassword);
  };
  useEffect(() => {
    if(changeStatus == true){
      setChangeStatus(false)
      setShowUpdatePasswordModal(false)
    }
  
  }, [handleClose])
 
 
  useEffect(() => {
    if (loading == false) {
      setTimeout(function () {
        setAlertMessage({
          open: false,
        });
      }, 3000);
    }
  }, [loading]);

    // function for change the checkbox status
    const handleCheckbox = () => {
      setCheck_status(!check_status);
    };
  return (
    <div id="login">
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={alertMessage.open}
        className={alertMessage.alertSuccess ? "success-alert" : "danger-alert"}
      >
        {alertMessage.alertSuccess ? (
          <Alert severity="success">{alertMessage.message}</Alert>
        ) : (
          <Alert severity="error">{alertMessage.message}</Alert>
        )}
      </Snackbar>

      <SignUpDialog
        open={openSignUp}
        handleClickOpen={handleClickOpenSignUp}
        handleClose={handleCloseSignUp}
        handleLoginOpen={handleLoginOpen}
      />

      <Dialog
        className="Login-Modal  p-0 "
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {/* Modal title */}
        </DialogTitle>

        {showUpdatePasswordModal ? (
          <UpdatePasswordModal userId={userIdForUpdatePassword} />
        ) : (
          <>
            {changeStatus == false ? (
              <div
                style={
                  appState.langValue === "ar"
                    ? { direction: "rtl" }
                    : { direction: "ltr" }
                }
              >
                <div className="login-head">
                  <h2>{t("login.Login")}</h2>
                  <div
                    id="social-icons"
                    className="d-flex justify-content-center row m-0 "
                  >
                    <div className="innerdivSocialIcon pb-2 d-flex">
                      <FbLogin
                        fbloginHandleclose={handleClose}
                        fbloading={loading}
                        setfbLoading={setLoading}
                        setAlertMessage={setAlertMessage}
                      />

                      <LoginGoogle
                        loginHandleclose={handleClose}
                        loading={loading}
                        setLoading={setLoading}
                        setAlertMessage={setAlertMessage}
                      />

                      <AppleLogin
                        loginHandleclose={handleClose}
                        loading={loading}
                        setLoading={setLoading}
                        setAlertMessage={setAlertMessage}
                      />
                    </div>
                  </div>
                </div>

                <h6 className="text-muted text-center m-0 useAccount ">
                  {t("login.OR-use-Acount")}
                </h6>
                <form action=""  onSubmit={handleLoginSubmit}>
                  <div className="login-fields pb-1">
                    <div
                      className={`${
                        appState.langValue === "ar" ? "signUpPhoneNumber" : ""
                      } row mx-3`}
                    >
                      {/* <div  className="col-12 px-4 "> */}
                      <TextField
                        value={loginValues.email}
                        onChange={updateField}
                        name="email"
                        type="email"
                        variant="filled"
                        fullWidth="true"
                        id="input-with-icon-textfield"
                        placeholder={t("form.Email")}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start" className="mb-3">
                              <EmailIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                      {/* </div> */}
                    </div>
                    <div className="row mx-3 py-2 ">
                      <TextField
                        value={loginValues.password}
                        onChange={updateField}
                        name="password"
                        type={toggleCurrentPassword ? "text" : "password"}
                        variant="filled"
                        fullWidth="true"
                        id="input-with-icon-textfield"
                        placeholder={t("form.password")}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start" className="mb-3">
                              <LockIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={togglePassTypeCurrent}
                                onMouseDown={(e) => e.preventDefault()}
                              >
                                {toggleCurrentPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}

                        // InputProps={{

                        // }}
                      />
                    </div>
                    {/* </div> */}
                    <div className=" mx-3 py-0 align-items-center justify-content-between d-flex forget-field">
                      <div className="keepLogin">
                        <span>
                          <Checkbox
                            defaultChecked
                            color="default"
                            inputProps={{
                              "aria-label": "checkbox with default color",
                            }}
                          />
                        </span>
                        <span> {t("login.keep-me-login")}</span>
                      </div>
                      <div className="forgetPassModal">
                        <Button onClick={handleForget}>
                          {" "}
                          {t("login.Forget-Pass")}?
                        </Button>
                      </div>
                    </div>
                    <div className="row mx-3 d-flex align-items-center justify-content-center">
                      {/* <div className="col-12 px-4"> */}
                      <Button
                        variant="contained"
                        className={`bg-primary`}
                        disabled={loading}
                        type="submit"
                      >
                        {loading ? t("login.redirecting") : t("login.Login")}
                      </Button>
                      {loading && (
                        <span style={{ position: "fixed" }}>
                          {" "}
                          <CircularProgress
                            size={24}
                            className={classes.buttonProgress}
                          />{" "}
                        </span>
                      )}
                      ٖ{/* </div> */}
                    </div>
                    <div className="row mx-3 text d-flex justify-content-center py-2 ">
                      <p>
                        <span> {t("login.OR")}</span>
                      </p>
                    </div>
                    <div  className="row mx-3 registermodalDiv pb-2">
                      {/* <div className="col-12 px-4"> */}
                      <Link
                        onClick={handleClickOpenSignUp}
                        // to={`/register`}
                        className="register-btn text-primary"
                      >
                        {t("login.Register-New-Acc")}
                      </Link>
                      {/* </div> */}
                    </div>
                  </div>
                </form>
                {/* start forgot password */}
              </div>
            ) : (
              <div
                style={
                  appState.langValue === "ar"
                    ? { direction: "rtl" }
                    : { direction: "ltr" }
                }
              >
                <div className="login-head">
                  <h4>{t("login.forgot-pass")}</h4>
                </div>

                <form action="" onSubmit={handleSubmitForgotPassword}>
                  <div className="login-fields ">
                    <div
                      className={`${
                        appState.langValue === "ar" ? "signUpPhoneNumber" : ""
                      } row mx-3 py-2`}
                    >
                      <TextField
                        value={ForgotValues.email}
                        onChange={updateFieldForgot}
                        name="email"
                        type="email"
                        variant="filled"
                        disabled={loading}
                        fullWidth="true"
                        id="input-with-icon-textfield"
                        placeholder={t("login.Email-Address")}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start" className="mb-3">
                              <EmailIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>

                    <div className="row mx-3 d-flex align-items-center justify-content-center py-3">
                      <Button
                        variant="contained"
                        className={`bg-primary`}
                        disabled={loading}
                        type="submit"
                      >
                        {loading ? "Redirecting" : t("login.forgot-pass")}
                      </Button>
                      {loading && (
                        <span style={{ position: "fixed" }}>
                          {" "}
                          <CircularProgress
                            size={24}
                            className={classes.buttonProgress}
                          />{" "}
                        </span>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            )}
          </>
        )}
      </Dialog>
    </div>
  );
}

const UpdatePasswordModal = ({ userId }) => {
  const classes = useStyles();
  const appDispatch = useContext(DispatchContext)
  const [loading, setLoading] = useState(false);

  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
  });
  const appState = useContext(StateContext);

  const [UpdatePassWordValues, setUpdatePassWordValues] = useState({
    code: "",
    newPassword: "",
    ConfirmNewPassword: "",
  });
  const [success, setSuccess] = useState(false);
  const updateField = (e) => {
    setUpdatePassWordValues({
      ...UpdatePassWordValues,
      [e.target.name]: e.target.value,
    });
  };
  const { t } = useTranslation();

  const handleSubmitUpdatePassword = async (e) => {
    setLoading(true);
    setSuccess(false);
    e.preventDefault();

    if (
      UpdatePassWordValues.code &&
      UpdatePassWordValues.newPassword &&
      UpdatePassWordValues.ConfirmNewPassword !== ""
    ) {
      if (
        UpdatePassWordValues.newPassword ===
        UpdatePassWordValues.ConfirmNewPassword
      ) {
        try {
          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL}update/password`,

            {
              id: userId,
              code: UpdatePassWordValues.code,
              password: UpdatePassWordValues.newPassword,
            }
          );
          setLoading(false);
          setAlertMessage({
            open: true,
            message: response.data.message,
            alertSuccess: true,
          });
        } catch (e) {
          setLoading(false);
          handleError(e, appDispatch)
          setUpdatePassWordValues({});
        }
      } else {
        setLoading(false);
        setAlertMessage({
          open: true,
          message: "Password did not match",
          alertSuccess: false,
        });
      }
    } else {
      setLoading(false);
      setAlertMessage({
        open: true,
        message: "Please fill these fields!",
        alertSuccess: false,
      });
    }
  };
  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={alertMessage.open}
        className={alertMessage.alertSuccess ? "success-alert" : "danger-alert"}
        autoHideDuration={4000}
      >
        {alertMessage.alertSuccess ? (
          <Alert severity="success">{alertMessage.message}</Alert>
        ) : (
          <Alert severity="error">{alertMessage.message}</Alert>
        )}
      </Snackbar>
      <div className="login-head">
        <h4>{t("form.UPDATE-PASSWORD")}</h4>
      </div>

      <form action="" onSubmit={handleSubmitUpdatePassword}>
        <div
          style={
            appState.langValue == "ar"
              ? { direction: "rtl" }
              : { direction: "ltr" }
          }
          className="login-fields "
        >
          <div className="row mx-3">
            <TextField
              value={UpdatePassWordValues.code}
              onChange={updateField}
              name="code"
              type="number"
              variant="filled"
              fullWidth="true"
              id="input-with-icon-textfield"
              placeholder={t("form.Enter-your-code")}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" className="mb-3">
                    <LockIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          {/* </div> */}

          <div className="row mx-3">
            <TextField
              value={UpdatePassWordValues.newPassword}
              onChange={updateField}
              name="newPassword"
              type="password"
              variant="filled"
              fullWidth="true"
              id="input-with-icon-textfield"
              placeholder={t("form.new-pass")}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" className="mb-3">
                    <LockIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="row mx-3">
            <TextField
              value={UpdatePassWordValues.confirmNewPassword}
              onChange={updateField}
              name="ConfirmNewPassword"
              type="password"
              variant="filled"
              fullWidth="true"
              id="input-with-icon-textfield"
              placeholder={t("form.confirm-new-pass")}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" className="mb-3">
                    <LockIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>

          <div className="row mx-3 d-flex align-items-center justify-content-center">
            <Button
              variant="contained"
              className={`bg-primary`}
              disabled={loading}
              type="submit"
            >
              {loading ? "Redirecting" : t("form.UPDATE-PASSWORD")}
            </Button>
            {loading && (
              <span style={{ position: "fixed" }}>
                {" "}
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />{" "}
              </span>
            )}
          </div>
        </div>
      </form>
      {/* start forgot password */}
    </div>
  );
};
export default withTranslation()(LoginDialog);
